function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_dddd)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 63.082,
  y: 34,
  width: 3.00521,
  height: 68,
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_dddd)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.0026,
  height: 68.059,
  transform: "matrix(0.70772 -0.706493 0.70772 0.706493 39.4375 45.019)",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_dddd)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.0026,
  height: 68.059,
  transform: "matrix(0.70772 0.706493 -0.70772 0.706493 87.6055 42.8979)",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_dddd)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30.5254,
  y: 69.5,
  width: 3,
  height: 68.118,
  transform: "rotate(-90 30.5254 69.5)",
  fill: "white"
})), /*#__PURE__*/React.createElement("rect", {
  x: 99.1445,
  y: 66,
  width: 4,
  height: 16.0278,
  transform: "rotate(90 99.1445 66)",
  fill: "#CFABFA"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 65.0032,
  cy: 67.918,
  rx: 20.9543,
  ry: 20.918,
  fill: "#8F5DE2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.6632 80.7483C77.8344 85.6642 71.7962 88.8355 65.0031 88.8355C58.3418 88.8355 52.4064 85.7861 48.5684 81.0325C53.3949 78.2128 59.165 76.5732 65.3642 76.5732C71.3521 76.5732 76.9397 78.1029 81.6632 80.7483Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 64.6415,
  cy: 64.672,
  rx: 8.30948,
  ry: 8.29508,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 92.7326,
  cy: 96.6,
  rx: 6.61145,
  ry: 6.6,
  fill: "#BEBEBE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97.9888 100.648C96.7808 102.199 94.8756 103.199 92.7323 103.199C90.6306 103.199 88.7579 102.237 87.5469 100.738C89.0697 99.8479 90.8903 99.3306 92.8462 99.3306C94.7355 99.3306 96.4985 99.8132 97.9888 100.648Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 92.6179,
  cy: 95.5762,
  rx: 2.62178,
  ry: 2.61724,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 38.6388,
  cy: 39.6,
  rx: 6.61145,
  ry: 6.6,
  fill: "#BEBEBE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.8951 43.6479C42.687 45.1989 40.7819 46.1995 38.6386 46.1995C36.5368 46.1995 34.6641 45.2373 33.4531 43.7375C34.976 42.8479 36.7965 42.3306 38.7524 42.3306C40.6417 42.3306 42.4047 42.8132 43.8951 43.6479Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 38.5241,
  cy: 38.5762,
  rx: 2.62178,
  ry: 2.61724,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 36.6349,
  cy: 96.6,
  rx: 6.61145,
  ry: 6.6,
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.8912 100.648C40.6831 102.199 38.778 103.199 36.6347 103.199C34.5329 103.199 32.6602 102.237 31.4492 100.738C32.9721 99.8479 34.7926 99.3306 36.7485 99.3306C38.6378 99.3306 40.4008 99.8132 41.8912 100.648Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 36.5202,
  cy: 95.5762,
  rx: 2.62178,
  ry: 2.61724,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 64.5838,
  cy: 29.5,
  rx: 5.50955,
  ry: 5.5,
  fill: "#8F5DE2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.9637 32.8732C67.957 34.1659 66.3693 34.9998 64.5831 34.9998C62.8315 34.9998 61.2709 34.1979 60.2617 32.948C61.5308 32.2065 63.048 31.7754 64.678 31.7754C66.2525 31.7754 67.7217 32.1776 68.9637 32.8732Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 64.4895,
  cy: 28.6469,
  rx: 2.18482,
  ry: 2.18103,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 64.5838,
  cy: 106.5,
  rx: 5.50955,
  ry: 5.5,
  fill: "#8F5DE2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.9637 109.873C67.957 111.166 66.3693 112 64.5831 112C62.8315 112 61.2709 111.198 60.2617 109.948C61.5308 109.207 63.048 108.775 64.678 108.775C66.2525 108.775 67.7217 109.178 68.9637 109.873Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 64.4895,
  cy: 105.647,
  rx: 2.18482,
  ry: 2.18103,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 90.8306,
  cy: 40.7,
  rx: 7.71336,
  ry: 7.7,
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.9637 45.4231C95.5543 47.2327 93.3316 48.4001 90.831 48.4001C88.3789 48.4001 86.1941 47.2776 84.7812 45.5278C86.5579 44.4898 88.682 43.8862 90.964 43.8862C93.1681 43.8862 95.2249 44.4493 96.9637 45.4231Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 90.6974,
  cy: 39.5051,
  rx: 3.05875,
  ry: 3.05345,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.7134,
  cy: 67.7,
  rx: 7.71336,
  ry: 7.7,
  fill: "#8F5DE2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.8465 72.4231C28.4371 74.2327 26.2144 75.4001 23.7138 75.4001C21.2617 75.4001 19.0769 74.2776 17.6641 72.5278C19.4408 71.4898 21.5648 70.8862 23.8468 70.8862C26.051 70.8862 28.1078 71.4493 29.8465 72.4231Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.5802,
  cy: 66.5051,
  rx: 3.05875,
  ry: 3.05345,
  fill: "white"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 109.071,
  cy: 67.9099,
  rx: 10.9288,
  ry: 10.9099,
  fill: "#8F5DE2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 108.127,
  y: 62.4771,
  width: 2.00347,
  height: 10,
  rx: 1.00174,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 114.137,
  y: 66.4771,
  width: 2,
  height: 10.0174,
  rx: 1,
  transform: "rotate(90 114.137 66.4771)",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 6,
  y: 18,
  width: 124,
  height: 108,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_dddd",
  x: -83.9752,
  y: -83.3951,
  width: 297.12,
  height: 362.114,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.72157
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.7042
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8.8903
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 22.0379
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 15.8588
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 39.3119
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 29.6621
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 73.5286
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow",
  result: "effect4_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect4_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_dddd",
  x: -107.62,
  y: -74.4974,
  width: 344.406,
  height: 344.319,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.72157
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.7042
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8.8903
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 22.0379
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 15.8588
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 39.3119
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 29.6621
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 73.5286
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow",
  result: "effect4_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect4_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_dddd",
  x: -107.618,
  y: -74.4971,
  width: 344.406,
  height: 344.319,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.72157
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.7042
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8.8903
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 22.0379
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 15.8588
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 39.3119
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 29.6621
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 73.5286
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow",
  result: "effect4_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect4_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_dddd",
  x: -116.532,
  y: -50.8951,
  width: 362.232,
  height: 297.114,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.72157
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.7042
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8.8903
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 22.0379
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 15.8588
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 39.3119
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 29.6621
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 73.5286
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow",
  result: "effect4_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect4_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 136,
  height: 136,
  rx: 12,
  fill: "white"
})));

var SvgCommunityIcon = function SvgCommunityIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommunityIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/community-icon.297799c4.svg";
export { ForwardRef as ReactComponent };